export enum AnalysisStatus {
  TO_BE_ANALYSED = 'TO_BE_ANALYSED',
  ANALYSING = 'ANALYSING',
  ANALYSIS_COMPLETED = 'ANALYSIS_COMPLETED',
  CAUTION = 'CAUTION',
}

export enum QC_STATUS {
  PROCESSING = 'PROCESSING',
  PASSED = 'PASSED',
  FAILED = 'FAILED',
}

export enum UPLOAD_SAMPLE_ERROR {
  WRONG_FORMAT = 'WRONG_FORMAT',
  WRONG_FORMAT_KIT_ID = 'WRONG_FORMAT_KIT_ID',
  NEED_MORE_FILE_SAMPLE = 'NEED_MORE_FILE_SAMPLE',
  NEED_MORE_FILE_SAMPLE_KIT = 'NEED_MORE_FILE_SAMPLE_KIT',
  WRONG_TYPE_FILE = 'WRONG_TYPE_FILE',
  LEAST_TWO_FILES = 'LEAST_TWO_FILES',
  CHARACTERS_LENGTH = 'CHARACTERS_LENGTH',
  MAXIMUM_FILES_UPLOAD = 'MAXIMUM_FILES_UPLOAD',
}

export enum ANALYSIS_ERROR_KEY {
  FASTQ_ERROR_MESSAGE = 'fastq_error_message',
}

export const MAX_CHARACTERS = 35;

export enum ANALYSIS_CHARACTERS {
  MIN = 6,
  MAX = 20,
}

export enum AnalysisBatchClientType {
  COMMERCIAL = 'COMMERCIAL',
  RESEARCH = 'RESEARCH',
}
